import type {CancellablePromise} from '@yourcoach/async-utils';

import {delay} from '@yourcoach/async-utils';

import type {BatchRpcRequest, RpcRequest} from './types';

import {ErrorResourceUserExpiredSession} from '../../../utils/errors/api';
import {REPEAT_DELAY} from './constants';

export async function handleExpiredJWT({
  apiRequestFn,
  args,
  delayPromisesMap,
  methodsString,
}: {
  apiRequestFn: any;
  args: BatchRpcRequest | RpcRequest;
  delayPromisesMap: Record<string, CancellablePromise<unknown>>;
  methodsString: string;
}) {
  apiRequestFn.setAccessToken({
    expires: 0,
    token: null,
  });

  if (methodsString.includes('auth.refresh')) {
    throw new ErrorResourceUserExpiredSession();
  }

  delayPromisesMap[methodsString] = delay(REPEAT_DELAY);
  await delayPromisesMap[methodsString];

  return apiRequestFn(args);
}
